import { Box } from '@mui/material'
import Grid from '@mui/material/Grid2'
import React, { useState } from 'react'
import shape from "../assets/Images/shapes/HomecardsThread-01.png"
import BookAppointmentDialog from './BookAnAppointmentDialogue'
import shap1 from "../assets/Images/serviceIcon/website icon-14.png"
import shap2 from "../assets/Images/serviceIcon/website icon-15.png"
import shap3 from "../assets/Images/serviceIcon/website icon-16.png"
import shap4 from "../assets/Images/serviceIcon/website icon-17.png"
import shap5 from "../assets/Images/serviceIcon/website icon-18.png"
import shap6 from "../assets/Images/serviceIcon/website icon-19.png"
export default function AboutvaluesCards() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  return (
    <div>
      <div id='value' className='overflow-hidden py-[88px] lg:py-[240px] relative'>
        <div className='max-w-[1340px] mx-auto relative'>
          <div className='relative'>
            <div className='z-[1]'>
              <div className='block md:flex justify-center items-center mb-[40px]'>
                <div data-aos="fade-right" className='lg:w-[562px] md:w-full me-auto'>
                  <h2 className=' text-[36px] lg:text-[58px] font-heading  text-thickGreen leading-[1.138em] mb-[24px]'>
                    Our Principles Pillars That Define Us
                  </h2>
                  <p className='text-paraGreen font-body font-medium text-[18px] leading-[1.667em]'>
                    We at MagnAid Hospitals are dedicated to providing premium healthcare followed by compassionate care and top-notch medical services for our patient’s wellness.
                  </p>
                </div>
                <button
                  onClick={handleOpenDialog}
                  className='bg-orange text-white px-7 py-6 rounded-full  font-medium  text-[20px] leading-[1.112em] 
       transition-all duration-300 hover:bg-lightGreen hover:bg-opacity-90 
       hover:translate-y-[-3px] block md:inline-block text-center mr-[0] md:mr-[24px] mt-8 lg:mt-0'
                >
                  Book an Appointment
                </button>
              </div>
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={4}>
                  <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <div className='mt-0 md:mt-[80px]' data-aos="fade-up" data-aos-easing="ease-in-back"
                      data-aos-delay="100">
                      <div className='p-[72px_40px_64px] bg-lightOrange shadow-none rounded-[24px]'>
                        <img
                          src={shap1}
                          alt='medical services'
                          className='  mb-[12px]'
                        />
                        <h3 className='text-[28px] font-heading  leading-[1.429em] mb-[16px] text-thickGreen'>
                          Premium Healthcare
                        </h3>
                        <p className='text-paraGreen font-body font-medium text-[18px] leading-[1.667em]'>
                          We are committed to offer qualitied healthcare to everyone irrespective  of their social or financial conditions.
                        </p>
                      </div>
                      <div className=' mt-[35px] p-[72px_40px_64px] bg-lightOrange shadow-none rounded-[24px]'>
                        <img
                          src={shap4}
                          alt='top private hospitals in hyderabad'
                          className='  mb-[12px]'
                        />
                        <h3 className='text-[28px] font-heading font-medium leading-[1.429em] mb-[16px] text-thickGreen'>
                          Compassionate Care
                        </h3>
                        <p className='text-paraGreen font-body font-medium text-[18px] leading-[1.667em]'>
                          Our expert specialist at MagnAid hospital offer compassionate and personalised care with extreme understanding.
                        </p>
                      </div>
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <div data-aos="fade-up" data-aos-easing="ease-in-back"
                      data-aos-delay="200">
                      <div className='p-[72px_40px_64px] bg-lightOrange shadow-none rounded-[24px]'>
                        <img
                          src={shap2}
                          alt='Best hospitals in hyderabad'
                          className='  mb-[12px]'
                        />
                        <h3 className='text-[28px] font-heading font-medium leading-[1.429em] mb-[16px] text-thickGreen'>
                          Excellent  Medical Services
                        </h3>
                        <p className='text-paraGreen font-body font-medium text-[18px] leading-[1.667em]'>
                          We are dedicated to delivering compassionate care with advanced technologies.
                        </p>
                      </div>
                      <div className=' mt-[35px]  p-[72px_40px_64px] bg-lightOrange shadow-none rounded-[24px]'>
                        <img
                          src={shap5}
                          alt='best surgeons in hyderabad'
                          className='  mb-[12px]'
                        />
                        <h3 className='text-[28px] font-heading font-medium leading-[1.429em] mb-[16px] text-thickGreen'>
                          Skilled Surgeons
                        </h3>
                        <p className='text-paraGreen font-body font-medium text-[18px] leading-[1.667em]'>
                          Our surgeons are highly skilled and experienced in delivering successful surgeries using advanced technologies.
                        </p>
                      </div>
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                    <div className=' lg:block md:flex sm:block gap-7 lg:mt-[-80px]' data-aos="fade-up" data-aos-easing="ease-in-back"
                      data-aos-delay="300">
                      <div className='p-[72px_40px_64px] bg-lightOrange shadow-none rounded-[24px]'>
                        <img
                          src={shap3}
                          alt='best hospital in hyderabad'
                          className='  mb-[12px]'
                        />
                        <h3 className='text-[28px] font-heading font-medium leading-[1.429em] mb-[16px] text-thickGreen'>
                          Patient-centric approch
                        </h3>
                        <p className='text-paraGreen font-body font-medium text-[18px] leading-[1.667em]'>
                          We ensure to give our patients the top-notch patient experience with  our excellent nursing services.
                        </p>
                      </div>
                      <div className='mt-[35px] md:mt-[-80px] lg:mt-[35px] p-[72px_40px_64px] bg-lightOrange shadow-none rounded-[24px]'>
                        <img
                          src={shap6}
                          alt='Multi Speciality Hospital in Hyderabad'
                          className='  mb-[12px]'
                        />
                        <h3 className='text-[28px] font-heading font-medium leading-[1.429em] mb-[16px] text-thickGreen' >
                          Community services
                        </h3>
                        <p className='text-paraGreen font-body font-medium text-[18px] leading-[1.667em]'>
                          We conduct healthcare and awareness camps from time to time for the well being of underprivileged community.
                        </p>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Box>
              <div>
                <img src={shape} alt="shape" className='absolute z-[-1] inset-[-6%_-35%_0%_auto]' />
              </div>
            </div>
          </div>
        </div>
      </div>
      <BookAppointmentDialog open={dialogOpen} onClose={handleCloseDialog} />
    </div>
  )
}
